/**
 * Backend TransformInterceptor envelope unwrap helper.
 *
 * NestJS の TransformInterceptor は全レスポンスを
 * `{ statusCode, message, data, timestamp }` 形式でラップする。
 * `apiClient` (axios) 経由の通信は interceptor で自動剥がしされるが、
 * 生 `fetch` 使用箇所ではこのヘルパーで明示的に unwrap する必要がある。
 *
 * @see services/apiClient.ts (axios response interceptor)
 * @see backend/src/common/interceptors/transform.interceptor.ts
 * @see Issue #2849
 */

type EnvelopeShape = {
  statusCode: number;
  message: string;
  data: unknown;
  timestamp?: string;
};

/**
 * TransformInterceptor envelope か判定する type guard。
 * キーの存在だけでなく `statusCode: number` と `message: string` も検証することで、
 * 業務ペイロードが偶然 `{statusCode, message, data}` 形状を持つケース (例: エラー DTO) を
 * envelope と誤認してアンラップする事故を防ぐ。
 */
function isEnvelope(raw: unknown): raw is EnvelopeShape {
  if (raw === null || typeof raw !== 'object') {
    return false;
  }
  const candidate = raw as Record<string, unknown>;
  return (
    typeof candidate.statusCode === 'number' &&
    typeof candidate.message === 'string' &&
    'data' in candidate
  );
}

export function unwrapEnvelope<T>(raw: unknown): T {
  if (isEnvelope(raw)) {
    return raw.data as T;
  }
  return raw as T;
}
